import { type Session } from '@/entities/session';
import { useExecuteOnce } from '@/shared/lib';
import { usePhoneVerificationModals } from './usePhoneVerificationModals';

const usePhoneVerificationModalAfterLogin = (session: Session | null) => {
  const { openPhoneVerificationModal } = usePhoneVerificationModals();

  const isPhoneRequired = !session?.additional?.isPhone;

  const userId = session?.userId;

  const shouldShowModal = Boolean(userId && isPhoneRequired);

  useExecuteOnce(() => {
    if (!userId) return;

    openPhoneVerificationModal({
      identity: undefined,
    });
  }, shouldShowModal);
};

export { usePhoneVerificationModalAfterLogin };
